export const ROUTES = {
  FUNDRAISING_PAGES: '*',
};
